(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareDialogController', TabFirmwareDialogController);

    TabFirmwareDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabFirmware', 'DataUtils', 'TabObjectTypes', '$state', 'AlertService','ParseLinks'];

    function TabFirmwareDialogController($timeout, $scope, $stateParams, $q, entity, TabFirmware, DataUtils, TabObjectTypes, $state, AlertService,ParseLinks) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.tabFirmwareInactive = [];
        vm.tabObjectTypes = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFirmwareUpdate', result);
            vm.isSaving = false;
            $state.go('tab-firmware');
        };

        var onSaveError = function () {
            vm.isSaving = false;
            AlertService.error("Error saving firmware file");
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFirmware.id !== null) {
                TabFirmware.update(vm.tabFirmware, onSaveSuccess, onSaveError);
            } else {
                TabFirmware.save(vm.tabFirmware, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-firmware');
        };

        vm.setFileContent = function ($file, tabFirmware) {
            if ($file) {
                if($file.type === "srec" || $file.name.indexOf(".srec") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "SREC";
                        });
                    });
                    vm.tabFirmware.extension = ".srec";
                } else if($file.type === "hex" || $file.name.indexOf(".hex") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "HEX";
                        });
                    });
                    vm.tabFirmware.extension = ".hex";
                } else if($file.type === "bin" || $file.name.indexOf(".bin") >= 0 ) {
                    DataUtils.toBase64($file, function (base64Data) {
                        $scope.$apply(function () {
                            tabFirmware.firmwareBody = base64Data;
                            tabFirmware.fileContentType = "BIN";
                        });
                    });
                    vm.tabFirmware.extension = ".bin";
                } else {
                    AlertService.error("The file type is not 'srec', 'hex' or 'bin', are you sure is a firmware file");
                }
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.isSameVersion = function () {
            return vm.tabFirmware.version === document.getElementById("field_currentVersion").value || vm.checkVersionOverride();
        };

        vm.loadInactive = function(tabFirmwareActive) {
            TabFirmware.load({address: tabFirmwareActive.address, objectTypeId: tabFirmwareActive.objectType.id, idShowed : tabFirmwareActive.id}, null, onSuccess, onError);
            function onSuccess(data) {
                data.forEach(function (fw) {
                    vm.tabFirmwareInactive.push(fw);
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        TabFirmware.query().$promise.then(function (res) {
            res.forEach(function (fw) {
                vm.loadInactive(fw);
            });
        });

        vm.checkVersionOverride = function () {
            var found = false;
            if (vm.tabFirmwareInactive.length > 0) {
                vm.tabFirmwareInactive.forEach(function (entry) {
                    if (!found) {
                        found = entry.address === vm.tabFirmware.address && entry.version === vm.tabFirmware.version && entry.objectType.id === vm.tabFirmware.objectType.id;
                    }
                });
            }
            return found;
        };

        vm.loadAll = function () {
            TabObjectTypes.query({
                page: vm.page,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();
    }
})();
